module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/tea@2x_454d81.jpg";